"use client";

import { c as _c } from "react/compiler-runtime";
import ConditionalPromotionOffers from "../catalog/conditional-promotion-offers";
import React from "react";
import { FiCheckCircle } from "react-icons/fi";
import Button from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogTitle } from "@/components/ui/dialog";
import { formatCurrency } from "@/lib/format-data";
import type { ShopCartLine, ShopItem } from "@/types/shop";
import { packagePricingSummary } from "./pricing";
interface PackageDetailsDialogProps {
  item: ShopItem | null;
  catalogItems?: ShopItem[];
  cartLines?: ShopCartLine[];
  onConfirm: (item: ShopItem) => void;
  onQuickAddPromotionItem?: (itemId: string, quantity: number) => void;
  onCancel: () => void;
}
const PackageDetailsDialog: React.FC<PackageDetailsDialogProps> = t0 => {
  const $ = _c(49);
  const {
    item,
    catalogItems: t1,
    cartLines: t2,
    onConfirm,
    onQuickAddPromotionItem,
    onCancel
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const catalogItems = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const cartLines = t4;
  const open = item !== null;
  let T0;
  let T1;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] !== cartLines || $[5] !== catalogItems || $[6] !== item || $[7] !== onCancel || $[8] !== onQuickAddPromotionItem || $[9] !== open) {
    const pricing = item ? packagePricingSummary(item) : null;
    let t11;
    if ($[18] !== item?.packageIncludedItems) {
      t11 = item?.packageIncludedItems ?? [];
      $[18] = item?.packageIncludedItems;
      $[19] = t11;
    } else {
      t11 = $[19];
    }
    const includedItems = t11;
    T1 = Dialog;
    t9 = open;
    if ($[20] !== onCancel) {
      t10 = nextOpen => !nextOpen ? onCancel() : null;
      $[20] = onCancel;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    T0 = DialogContent;
    t5 = "max-w-xl gap-0 overflow-hidden p-0";
    const t12 = item ? `Review ${item.name}` : "Review package";
    if ($[22] !== t12) {
      t6 = <DialogTitle className="sr-only">{t12}</DialogTitle>;
      $[22] = t12;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <DialogDescription className="sr-only">Review package contents and pricing before adding it.</DialogDescription>;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    t8 = item && pricing && <div className="min-h-0 flex-1 overflow-y-auto px-6 py-7 md:px-8 md:py-8"><header className="grid gap-5 pb-6 md:grid-cols-[minmax(0,1fr)_auto] md:items-start"><div className="min-w-0">{item.category && <p className="text-micro font-semibold uppercase tracking-[0.2em] text-primary/70">{item.category}</p>}<h2 className="mt-2 text-h2 leading-tight text-foreground">{item.name}</h2>{item.description && <p className="mt-3 max-w-prose whitespace-pre-line text-body leading-relaxed text-foreground-secondary">{item.description}</p>}</div><div className="md:min-w-36 md:text-right"><p className="mt-1 font-serif text-[2rem] font-medium leading-none tracking-tight text-foreground tabular-nums md:text-[2.25rem]">{formatCurrency(pricing.price)}</p>{pricing.savings > 0 && <p className="mt-2 text-body-emphasis text-primary">Save {formatCurrency(pricing.savings)}</p>}</div></header><section className="mt-4 border-t border-border">{includedItems.length > 0 ? <ul className="mt-2 divide-y divide-border border-border">{includedItems.map(_temp)}</ul> : <p className="max-w-prose text-body leading-relaxed text-foreground-secondary">This package is added to your account after payment. The clinic will apply the package benefits when eligible items are used.</p>}</section><div className="mt-5 flex items-start gap-2 text-caption text-foreground-secondary"><FiCheckCircle className="mt-0.5 h-4 w-4 flex-none text-primary" /><p>Package benefits are available immediately after checkout</p></div>{onQuickAddPromotionItem && <ConditionalPromotionOffers item={item} catalogItems={catalogItems} cartLines={cartLines} onQuickAdd={onQuickAddPromotionItem} />}</div>;
    $[4] = cartLines;
    $[5] = catalogItems;
    $[6] = item;
    $[7] = onCancel;
    $[8] = onQuickAddPromotionItem;
    $[9] = open;
    $[10] = T0;
    $[11] = T1;
    $[12] = t10;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    T0 = $[10];
    T1 = $[11];
    t10 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
    t8 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span>Cancel</span>;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== onCancel) {
    t12 = <Button variant="secondary" onClick={onCancel} className="cursor-pointer">{t11}</Button>;
    $[26] = onCancel;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== item || $[29] !== onConfirm) {
    t13 = () => item && onConfirm(item);
    $[28] = item;
    $[29] = onConfirm;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span>Add package</span>;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13) {
    t15 = <Button variant="primary" onClick={t13} className="cursor-pointer">{t14}</Button>;
    $[32] = t13;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t12 || $[35] !== t15) {
    t16 = <DialogFooter>{t12}{t15}</DialogFooter>;
    $[34] = t12;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== T0 || $[38] !== t16 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8) {
    t17 = <T0 className={t5}>{t6}{t7}{t8}{t16}</T0>;
    $[37] = T0;
    $[38] = t16;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== T1 || $[45] !== t10 || $[46] !== t17 || $[47] !== t9) {
    t18 = <T1 open={t9} onOpenChange={t10}>{t17}</T1>;
    $[44] = T1;
    $[45] = t10;
    $[46] = t17;
    $[47] = t9;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
};
export default PackageDetailsDialog;
function _temp(includedItem, index) {
  return <li key={includedItem.itemId ?? `${includedItem.name}-${index}`} className="flex items-start gap-4 py-4">{includedItem.imageUrl && <img src={includedItem.imageUrl} alt={includedItem.name} width={64} height={64} loading="lazy" className="h-16 w-16 flex-none rounded-lg bg-muted object-cover" />}<div className="grid min-w-0 flex-1 grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-1"><p className="min-w-0 truncate text-body-emphasis text-foreground">{includedItem.name}</p><p className="text-right text-body-emphasis text-foreground tabular-nums">{includedItem.retailTotal !== null ? formatCurrency(includedItem.retailTotal) : null}</p><div className="min-w-0 space-y-1">{includedItem.description && <p className="line-clamp-2 text-caption leading-relaxed text-foreground-secondary">{includedItem.description}</p>}<p className="text-caption text-foreground-secondary">{includedItem.unitPrice !== null ? `${includedItem.quantity} × ${formatCurrency(includedItem.unitPrice)} each` : `${includedItem.quantity} included`}</p></div><p className="text-right text-caption text-foreground-secondary">{includedItem.retailTotal !== null ? "Retail value" : null}</p></div></li>;
}